// This file is generated and hand-edited. Source of truth for the "models" namespace.
// See docs/locales.md for naming conventions and tooling.

export const models = {
  assistant: {
    tab: {
      title: "Getting started",
      subtitle:
        "It looks like you're just getting started. We recommend using the Assistant to guide you through the initial setup and help you link essential data.",
      button: "Get started",
    },
    page: {
      stepsCount: "Step {current} of {total}",
      actions: {
        nextStep: "Save and continue",
        previousStep: "Previous step",
        cancel: "Cancel",
        continue: "Continue",
        turnOffHints: "Turn off hints",
        complete: "Add a team member",
      },
      steps: {
        orthoCompanies: {
          title: "Orthodontist Practice",
          addTitle: "Add Orthodontist Practice",
          hintModal: {
            title: "Orthodontist Practice – Legal Entity Setup",
            text: "You’ll be entering the main details for the Orthodontic Practice - the legal entity that owns the offices. All required information is in the contract, so it’s best to have it on hand and copy the details directly.",
          },
        },
        gpCompanies: {
          title: "GP Practice",
          addTitle: "Add GP Practice",
          hintModal: {
            title: "Now let’s add the GP Practice",
            text: "This is the legal entity behind the general office. Again, all the required information should be in the contract - have it nearby so you can copy everything accurately.",
          },
        },
        contracts: {
          title: "Contract",
          addTitle: "Add contract",
          hintModal: {
            title: "Adding a contract",
            text: "To create a contract, you’ll need to select both entities involved - the Orthodontist Office and the GP Office - and provide the dates from the contract. Make sure both offices are already filled in before continuing.",
          },
        },
        orthoPractices: {
          title: "Orthodontist Offices",
          addTitle: "Add Orthodontist Offices",
          hintModal: {
            title: "Let’s add Orthodontic Offices",
            text: "We’ll now set up the individual Orthodontic Offices. You’ll be asked to enter several details - but don’t worry, only these few are required to continue:",
            bullets: [
              "Office name",
              "Office ID",
              "Orthodontic Practice",
              "E-Mail addresses",
              "Office addresses",
            ],
            afterText:
              "You can add more than one office, and you’ll be able to come back and edit them later if needed.",
          },
        },
        gpPractices: {
          title: "GP Offices",
          addTitle: "Add GP Offices",
          hintModal: {
            title: "Now let’s add GP Offices",
            text: "Just like with the Orthodontist Offices, we’ll now add the general offices. To proceed, please provide these required details for each one:",
            bullets: ["Office name", "Office ID", "GP Practice", "Office addresses"],
            afterText:
              "You can add more than one, and you’ll be able to update them later if needed.",
          },
        },
        complete: {
          title: "Complete",
          addTitle: "Complete",
          subtitle:
            "Now that all practices, contracts,and offices are in place, congratulations! It’s time to start adding your team members.\n\n The Assistant has completed its work, and you can now add member via button bellow or in the the Administrative tab latter.",
          mainTitle: "Great job - you’ve set up your full business structure!",
        },
      },
    },
  },
  auth: {
    privacyPolicy: {
      privacyPolicy: "Privacy Policy",
    },
    login: {
      success: "You have successfully logged in",
      loginAs: "Login as {email}",
    },
    connect: {
      about: "About Us",
    },
    resetPassword: {
      title: "Forgotten your password?",
      success: "We have sent you an e-mail with instructions to reset your password",
    },
    resetPasswordConfirm: {
      title: "Reset your password",
      success: "Your password has been successfully reset",
      passwordsMatch: "Passwords must match",
    },
    actions: {
      logIn: "Log in",
      resetPassword: "Request password reset",
      resetPasswordConfirm: "Confirm new password",
      forgotPassword: "Forgotten password?",
    },
    setPassword: {
      success: "Your password has been successfully set",
    },
    invitation: {
      title: "Setup your password",
      confirmPassword: "Confirm password",
    },
    sso: {
      subtitle: "Use your {name} account to continue.",
      continueWith: "Continue with {name}",
      usePassword: "Log in with email and password instead",
      processing: "Logging you in…",
      failureTitle: "Login failed",
      backToLogin: "Back to login",
      link: {
        title: "Connect your account",
        description:
          "A CoTreatMe account with {email} already exists. Enter its password to connect it to your {name} login. From then on, you will log in with {name} only.",
        submit: "Connect and log in",
      },
      errors: {
        access_denied: "The login was cancelled or denied by your organization.",
        invalid_state: "Your login attempt has expired. Please start again.",
        no_role:
          "Your account has no role assigned in CoTreatMe yet. Please contact your administrator.",
        no_email:
          "Your organization account has no email address. Please contact your administrator.",
        unverified_email:
          "Your organization has not verified your email address. Please contact your administrator.",
        link_required:
          "Your login could not be connected to your CoTreatMe account. Please start again.",
        account_exists:
          "A CoTreatMe account with your email address already exists. Please contact your administrator to connect it to your organization login.",
        no_practice:
          "Your account is not linked to any practice in CoTreatMe yet. Please contact your administrator.",
        inactive: "Your CoTreatMe account has been deactivated. Please contact your administrator.",
        failed: "Something went wrong while logging you in. Please try again.",
      },
    },
    users: {
      profile: {
        personalInformationTitle: "Personal information",
        photo: {
          title: "Profile picture",
          description: "PNG,JPEG under 15MB",
          uploadSuccess: "Profile picture uploaded successfully",
          deleteSuccess: "Profile picture deleted successfully",
        },
      },
      actions: {
        changePassword: "Change password",
        delete: "Delete account",
      },
      accountActions: {
        security: {
          title: "Security",
          changePassword: {
            description: "Keep your account secure by using a strong, unique password.",
          },
        },
        dangerZone: {
          title: "Irreversible Actions",
          deleteAccount: {
            title: "Delete Account",
            description:
              "Deleting your account removes your profile and access permanently. This cannot be undone.",
            inputPlaceholder: "Login Email",
            typeToConfirm: "Type your login email below to confirm.",
            unavailableTooltip:
              "Account deletion isn't available yet. Please contact support to delete your account.",
          },
        },
      },
      appPreferences: {
        title: "Application settings",
        dashboardNameFormat: "Dashboard Name Format",
        preferredAudioDevice: "Preferred Audio Device",
        noAudioDevicesAvailable: "No audio devices available",
        dashboardDefaultTab: "Default Dashboard Tab",
        administrativeAssistantHints: "Administrative Assistant Hints",
        administrativeAssistantHintsSubtitle: "Show helpful hints in the administrative interface",
        chatAssistantHints: "Chat Assistant Hints",
        chatAssistantHintsSubtitle: "Show helpful hints in messaging interfaces",
        darkMode: "Dark Mode",
        darkModeSubtitle: "Enable dark theme for the application",
        skipConfirmationDialogs: "Skip confirmation dialogs",
        skipConfirmationDialogsSubtitle: "Bypass confirmation prompts for non-financial actions",
        formCustomization: "Form customization (beta)",
        formCustomizationSubtitle: "Compact view and hideable sections in questionnaires",
      },
      password: {
        title: "Change Password",
        current: "Current Password",
        new: "New Password",
        confirm: "Confirm Password",
        currentRequired: "Current password is required.",
        newRequired: "New password is required.",
        tooShort: "Password must be at least 8 characters.",
        entirelyNumeric: "Password cannot be entirely numeric.",
        confirmRequired: "Please confirm your new password.",
        confirmMismatch: "Passwords do not match.",
        success: "Password changed successfully.",
      },
    },
  },
  company: {
    model: {
      publicName: "Doing Business As",
      addressesLegalEntity: "Address of the Legal Entity",
      pmsOptions: {
        opendental: "OpenDental",
      },
    },
    tableHeaders: {
      practiceCount: "@:generic.fields.sections.offices",
      staffCount: "Members",
      patientsTotal: "@:generic.dashboard.title",
    },
    contractFiles: {
      downloadAll: "Download all",
    },
  },
  invitations: {
    shareButton: "Share",
    acceptInvitation: "Accept invitation",
    registration: "Registration",
    invitationAccepted: "Invitation was accepted",
    invitationDeclined: "Invitation was declined",
    invitationDecisionHint: "Review the details below and accept or decline the invitation.",
    registrationHint: "Create your account and confirm your practice details to get started.",
    wrongUser: "This invitation is for a different user. Please sign in with the correct account.",
    organizationPresetHint: "You are joining this organization.",
    senderOrganization: "Invited by",
    joiningPractice: "Joining office",
    joiningCompany: "Joining practice",
    pendingInvitationsTitle: "Pending Invitations",
    noPendingInvitations: "No invitations found",
    revokeConfirm: {
      title: "Revoke invitation?",
      subtitleInvite: "Are you sure you want to revoke this invitation?",
      subtitleRecipient: "Are you sure you want to revoke the invitation for {email}?",
    },
    roleSelectionHint: "What role will this person have in your office?",
    specialtyLabel: "Specialization",
    rolePresetHint: "You were invited for this role.",
    accountSection: "Your account",
    resolved: {
      title: "Invitation unavailable",
      accepted: "This invitation has already been accepted.",
      rejected: "This invitation has already been declined.",
      revoked: "This invitation has been revoked.",
      expired: "This invitation has expired.",
    },
    companyTypeFromRoleHint: "Practice type is determined by the selected role and specialty.",
    newPractice: {
      title: "Practice details",
      subtitle: "You're registering a new practice. Tell us who it is and where you work from.",
      practiceHint: "The legal entity behind your offices.",
      officeHint: "The location you work from.",
      legalEntityExample: "e.g. Alpha Dental 112 LLC",
      officeNameExample: "e.g. Alpha Dental – Lampasas",
      officeNameHint: "The name patients know this office by, such as your brand name.",
    },
    error: {
      title: "Something went wrong",
      description: "Please contact customer support.",
      notFound: "This invitation doesn't exist or the link is no longer valid.",
    },
  },
  message: {
    now: "now",
    secondsAgo: "{count} sec ago",
    minutesAgo: "{count} min ago",
    hoursAgo: "{count} hours ago",
    reply: "Reply to",
    loadMore: "Load More Messages",
    message: {
      copiedToClipboard: "Message copied to clipboard",
      copyFailed: "Failed to copy message to clipboard",
    },
    emoji: {
      noEmojiFound: "No emoji found 🧐",
      searchEmoji: "Search emoji...",
    },
    chat: {
      emptyPlaceholder: {
        title: "No message yet",
        subtitle: "Start the conversation by sending a message below",
        typing: "Type your message here...",
        noRoomSelected: "No room selected",
        noRoomSelectedCardHint: "Select a room for the person detail",
        openRoomsList: "Browse rooms",
        quickActions: {
          followUp: "Follow up",
          shareUpdate: "Share update",
        },
        quickActionsTemplates: {
          followUp: [
            "Hi, just following up on this. Any updates?",
            "Just checking in. Any news on this?",
            "Wanted to follow up. How are things looking?",
          ],
          shareUpdate: ["Quick update: ", "Here's a quick update: ", "Wanted to share an update: "],
        },
      },
      roomTabs: {
        dm: "DM",
      },
      fontStyle: {
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        strike: "Strikethrough",
      },
    },
  },
  mso: {
    sharedPool: "Shared pool",
    sharedPoolFull: "Shared pool full",
    available: "{count} available",
    poolUsageCaption: "{percent}% of the shared {limit} pool used across all offices.",
    poolFullCaption:
      "Pool is full. No office can add connections until some free up or the plan is upgraded.",
    connections: "Connections (shared pool)",
    monthlyInvoice: "Monthly (single invoice)",
    poolInfoTitle: "How the DSO pool works",
    poolInfoBody:
      "Every office in this DSO draws from {sharedPool}, no matter how many connections any one office is using. Once it runs out, {noMore} until some free up or the plan is upgraded.",
    poolInfoBodySharedPool: "the same pool of connections",
    poolInfoBodyNoMore: "no office can add more",
    supportTitle: "CoTreatMe Support",
    contactSupport: "Contact support",
    consolidatedBillingTitle: "Consolidated Billing",
    consolidatedBillingSubtitle:
      "One monthly ACH invoice covers every practice & office at the negotiated custom rate.",
    consolidatedBillingOffices: "{count} offices",
    consolidatedBillingTotal: "Total (consolidated ACH)",
    downloadLatestInvoice: "Download latest invoice",
    requestPlanUpgrade: "Request plan upgrade",
    affiliatedPractices: "Affiliated practices",
    practicesOfficesTitle: "Practices & Offices",
    nav: {
      dsoRepresentative: "DSO Representative",
    },
    representative: {
      portalSubtitle: "DSO Account Representative Portal - enterprise administration",
      tabOverview: "Overview",
      tabPlan: "Plan & Approvals",
      currentPlanStat: "Current plan",
    },
    currentPlan: {
      upgrade: {
        connectionsUnit: "{count} connections",
      },
    },

    invoiceDialog: {
      title: "Consolidated DSO Invoice",
      issued: "Issued",
      due: "Due",
      practices: "Practices",
      totalDue: "Total due",
      downloadPdf: "Download PDF",
      downloaded: "Consolidated invoice PDF downloaded",
    },

    sharedPoolCaption: "{count} connections available across the DSO",
    consolidatedBillingMore: "and {count} more",
  },
  notification: {
    filters: {
      all: "All",
      treatmentPlan: "Treatment Plan",
      message: "Message",
    },
    types: {
      patient_message: "New message",
      sync_message_to_dm: "Sync message to DM",
      sync_patient_to_dm: "Sync patient to DM",
      treatment_plan: "Treatment plan updated",
      contract: "Contract",
    },
    title: "Notification Center",
    messageDescription: "A new message has been sent to {patient_name}",
    treatmentPlanDescription: "{title} for {patient_name}",
    empty: "No notifications yet",
    markAllAsRead: "Mark all as read",
    viewAll: "View all notifications",
    menuTitle: "Notifications",
    unread: "Unread",
  },
  patient: {
    title: {
      treatment: "Treatment",
      guardian: "Guardian",
      addGuardian: "Add Guardian",
      noAnnotation: "No Annotation available | No Annotations available",
      noXRay: "No X-Ray available | No X-Rays available",
      noPhoto: "No Photo available | No Photos available",
      photo: "Photo | Photos",
      noIoScan: "No I/O Scan available | No I/O Scans available",
      ioScan: "I/O Scan | I/O Scans",
      xRay: "X-Ray | X-Rays",
      noCompositeView: "No Composite view available",
      compositeView: "Composite view",
      supportingDocument: "Supporting Document | Supporting Documents",
      document: "Document | Documents",
      noSupportingDocument: "No Supporting Document available | No Supporting Documents available",
    },
    table: {
      predefinedFilters: {
        all: "All patients",
        inTreatment: "In Treatment",
        inProgress: "In Progress",
        actionsNeeded: "Actions Needed",
        referralsIn: "Referrals In",
        referralsOut: "Referrals Out",
        archived: "Archived",
        /**
         * Page-qualified variants for the "Default Dashboard Tab" setting,
         * where the tabs of all three dashboards share one dropdown and the
         * bare labels above collide.
         */
        qualified: {
          cotreatmentActionsNeeded: "CoTreatment - Actions Needed",
          cotreatmentInProgress: "CoTreatment - In Progress",
          cotreatmentInTreatment: "CoTreatment - In Treatment",
          referralsActionsNeeded: "Referrals - Actions Needed",
          referralsIn: "Referrals - Incoming",
          referralsOut: "Referrals - Outgoing",
        },
      },
      headers: {
        action: "Action",
        insurance: "Insurance",
        linkedORT: "Assigned Orthodontist",
        linkedGP: "Assigned GP",
        linkedTC: "Assigned TC",
        status: "Referral Status",
        consultDate: "Consult Date",
        dateReferralSent: "Date Referral Sent",
      },
      senderKind: {
        team_member: "Team member",
        event: "Event",
        campaign: "Campaign",
      },
      filter: {
        lastUpdate: "Last Update",
        assignedGpOffice: "Assigned GP Office",
        assignedOrthoOffice: "Assigned Ortho Office",
      },
      noneLinkedORT: "Orthodontist not linked",
      noneLinkedGP: "GP not linked",
    },
    addEditForm: {
      previousOrthoTreatment: "Previous Orthodontic treatment",
      searchPmsPatients: "Search PMS Patients",
      pmsPatientSelected: "Patient data loaded from PMS",
      pmsPatientAlreadyExists: "This patient already exists in the system",
      pmsPatientAlreadyExistsSubtitle:
        "Open the existing patient record instead of creating a duplicate.",
      pmsNonPatientTitle: "This person is already in the system",
      pmsNonPatientSubtitle:
        "{name} exists here but is not a full patient yet. Continuing will edit their existing details instead of creating a new record.",
      pmsNonPatientSubtitleFallback:
        "This person exists here but is not a full patient yet. Continuing will edit their existing details instead of creating a new record.",
      pmsNonPatientAccept: "Continue editing",
      pmsPatientClaimedTitle: "This person is not available",
      pmsPatientClaimedSubtitle:
        "This person has already been claimed by another doctor, so their details can't be opened here.",
      pmsDetailMissingParams: "Selected PMS record is missing required identifiers",
      pmsDetailFetchFailed: "Could not load full PMS details - basic patient data was applied",
      pmsDetailLoading: "Loading patient details from PMS…",
      unknownInsuranceCompanyTitle: "Select insurance company",
      unknownInsuranceCompanySubtitle:
        'We couldn\'t match "{name}" to one of our insurance companies.',
      unknownInsuranceCompanyText:
        "Search below to select the correct one. If you need this company added, contact support.",
      relatedPeople: {
        title: "Related Persons",
        person: "Related Person",
        add: "Add Related Person",
        empty: "No related persons added.",
        guarantor: "Guarantor",
        insuranceSubscriber: "Insurance subscriber",
        alreadyInSystem:
          "This person is already in the system. You don't have access to edit their details.",
        guardianRequired: "A guardian is required for patients under 18.",
        /**
         * Sidebar alert above the list, shown while at least one person is listed. Names the role
         * still open — never a count of people, since one person can cover several roles, so an
         * already-listed person can be the one who takes it.
         */
        requiredRolesOne: "Still needed: a {role}. Someone already listed can take this role too.",
        /**
         * Same alert with nothing listed yet: "someone already listed" would name no one, so it
         * just states the requirement.
         */
        requiredRolesEmpty: "Patients under 18 need a guardian.",
        sameContacts: "Same contact details as patient",
        guardianType: "Type of Guardian",
        selectExistingPerson: "Select existing person",
        confirmPatientEdit: {
          title: "Edit patient details?",
          subtitle:
            "{name} is a patient in their own right. Saving will change their own patient record, not just their role here.",
        },
      },
      enterSearchTerm: "Enter a search term to find patients",
      pmsSearchHint: "Enter at least {min} and at most {max} characters to search",
      pmsSearchMinLength: "Enter at least {min} characters ({remaining} more required)",
      pmsSearchMaxLength: "Maximum {max} characters allowed ({over} too many)",
      invalidSearchLength: "Search term must be between {min} and {max} characters",
      treatmentPlan: {
        selected: "Selected treatment plan",
        noneSelected: "This patient has no treatment plan selected",
        referFromOffice: "Referring from GP office",
        referToOffice: "Referring to Office",
      },
    },
    publicAddForm: {
      title: "Patient Questionnaire",
      draftRestored: "Your previous entries were restored.",
      clearDraftConfirmTitle: "Discard your saved entries?",
      clearDraftConfirmBody: "This will remove your saved draft and let you start fresh.",
    },
    selfSchedule: {
      title: "Schedule Your Free Consultation",
      subtitle: "Choose from the available consultation slots below.",
      noAvailableSlots: "No available slots in this week — try another week.",
      book: "Confirm Appointment",
      notReady: "We're still finalizing your registration. Please try again in a moment.",
      retry: "Try Again",
      alreadyScheduled: "You've already booked a consultation for this referral.",
      confirmedTitle: "Appointment Confirmed!",
      confirmedBody: "Your consultation is scheduled for {when}.",
    },
    toggleBar: {
      contact: {
        heading: "Patient Contact",
        noContact: "Patient has no contact information.",
        writeEmail: "Write email",
      },
      insurance: {
        noInsurance: "Patient has no insurance information.",
      },
      guardianContact: {
        title: "Guardian Contact",
        noContact: "Guardian has no contact information.",
        minor: "Minor",
      },
      group: {
        heading: "Guardians",
      },
      files: {
        title: "Patient files",
      },
    },
    addPersonForm: {
      isPayer: "Payer",
      pickPerson: "Select existing patient",
    },
    linkEntity: {
      title: {
        gpPractice: "Link new GP office",
        orthoPractice: "Link to Orthodontic Office",
        ortho: "Link new Orthodontist",
        treatmentCoordinator: "Link new Treatment coordinator",
        gp: "Link new GP",
      },
      chooseEntity: "Choose {entity}",
      entitiesWithArticle: {
        gpPractice: "a GP office",
        orthoPractice: "an Orthodontic Office",
        ortho: "an Orthodontist",
        treatmentCoordinator: "a Treatment coordinator",
        gp: "a GP",
      },
      entitiesWithoutArticle: {
        gpPractice: "GP office",
        orthoPractice: "Orthodontic Office",
        ortho: "Orthodontist",
        treatmentCoordinator: "Treatment coordinator",
        gp: "GP",
      },
    },
    cooperateStaff: {
      title: {
        gp: "Link new GP",
        ortho: "Link new Orthodontist",
        tc: "Link new Treatment Coordinator",
      },
      chooseEntity: "Choose {entity}",
      entitiesWithArticle: {
        gp: "a GP",
        ortho: "an Orthodontist",
        tc: "a Treatment Coordinator",
      },
      entitiesWithoutArticle: {
        gp: "GP",
        ortho: "Orthodontist",
        tc: "Treatment Coordinator",
      },
    },
    noData: {
      title: "Let's Get You Started!",
      description:
        "Your dashboard is empty. Add a patient to get started and start managing your patients.",
    },
    status: {
      statusUnavailable: "Status unavailable",
      contactAttemptedNoResponse: "Contact Attempted - No Response",
      multipleAttemptsNoResponse: "Multiple Attempts - No Response",
      contactedRequestedCallback: "Contacted - Requested Callback",
      scheduled: "Consultation - Scheduled",
      rescheduled: "Consultation - Rescheduled",
      cancelled: "Consultation - Canceled",
      noShow: "Consultation - No-Show",
      // `consultation*`-prefixed keys below serve the still-unwired `EPatientStatus` (patient
      // contract flow), whose values keep the old long form — kept for that, not the consultation
      // status widget, which now reads the short-form keys above.
      consultationScheduled: "Consultation - Scheduled",
      consultationRescheduled: "Consultation - Rescheduled",
      consultationCanceled: "Consultation - Canceled",
      consultationNoShow: "Consultation - No-Show",
      consultationCompleted: "Consultation - Completed",
      declinedTreatment: "Declined Treatment",
      observationNotReady: "Observation - Not Ready",
      pendingStartNeeded: "Pending - Start Needed",
      contractStarted: "Contract Started",
      doctorDeclinedTreatment: "Doctor Declined Treatment",
      treatmentComplete: "Treatment Complete",
      noComment: "No comment",
      new: "New",
      referralDeclined: "Declined Referral",
    },
    statusDialog: {
      title: "Update referral status",
      subtitle:
        "Update the patient referral status shown on this card and optionally add a note for context.",
      previousStatusLabel: "Current Status",
      appointmentType: "Appointment type",
      noAvailableSlots: "No available slots for this appointment type",
      noSlotsThisDay: "No available slots on this day",
      selectAppointmentTypeFirst: "Select an appointment type to see available times",
      slotDuration: "Pick an available time below - each appointment is {minutes}.",
      loadingSlots: "Loading available times…",
      loadingSlotsSlow: "Still working - this can take a few seconds…",
    },
    card: {
      title: "Patient card",
      general: {
        linked: "Linked ",
      },
      emptyContents: {
        title: "No Patient Records",
        subtitlePerms: "Start the treatment process by filling the ",
        subtitleNoPerms: "No treatment plan has been started for this patient yet.",
      },
      practiceOwners: "Managing Offices of Patient",
      latestVersion: "Latest version",
      actions: {
        otherActions: "Other Actions",
        editPatient: "Edit Patient Details",
        editPatientState: "Change Referral Status",
        deletePatient: "Delete Patient",
      },
      quickstartProtocol: {
        title: "Quickstart Protocol",
        switch: "Switch Protocol",
        noProtocolRunning: "No protocol running",
        fetchError: "Unable to load status",
        selectTitle: "Change Quickstart Protocol",
        selectSubtitle:
          " Select a DentalMonitoring preset, switching replaces the current running protocol.",
        currentPlan: "Currently active",
        dmApp: {
          title: "DM Application",
          downloaded: "Downloaded",
          notDownloaded: "Not downloaded",
          resendLink: "Resend DM login link",
          resendLinkSent: "DM login link has been resent to the patient",
        },
      },
      monitoringAction: {
        pause: {
          title: "Pause Treatment",
        },
        resume: {
          title: "Resume Treatment",
        },
        resumeDate: "Resume Date",
        commentPlaceholder: "Enter a comment for patient (optional)",
      },
      error: {
        noFilesToOpen: "No files selected to open in viewer",
        failedToLoadFiles: "Failed to load files. Please try again.",
      },
      deletePatient: {
        description:
          "This will permanently delete the patient and all associated data. This action cannot be undone.",
        typeToConfirm: "Type the patient's full name below to confirm.",
        nameLabel: "Patient name",
        namePlaceholder: "Enter or paste patient name",
        waitCountdown: "Please wait {seconds} second(s) before confirming.",
      },
      fileLoadDialog: {
        title: "Files Already Loaded",
        message: "Some files are already loaded in the viewer. What would you like to do?",
        openExisting: "Open Already Loaded Files",
        loadNew: "Load New Files",
      },
      tooltips: {
        openViewer: "Load files in 3D viewer",
      },
    },
    shared: {
      noPatient: "No patient selected",
    },
    compositeView: {
      upload: "Composite upload photos",
      generated: "Composite view is being generated. It may take a few minutes.",
      pending: "Composite view is waiting to be generated.",
      inProgress: "Composite view is being processed.",
      failed: "Composite view generation failed.",
      assign: "Assign positions",
      reset: "Reset Active View",
      delete: "Delete Active View",
      deleteAll: "Delete All Views",
      editor: "Composite Editor",
      transform: "Transform",
      rotation: "Rotation",
      rotationPlus90: "Rotate +90",
      rotationMinus90: "Rotate -90",
      scale: "Scale",
      brightness_contrast: "Brightness / Contrast",
      brightness: "Brightness",
      contrast: "Contrast",
      alignment: "Alignment",
      grid: "Grid",
      guides: "Guides",
      girdSize: "Grid Size",
      flipX: "Flip X",
      flipY: "Flip Y",
      bulkUpload: "Bulk upload",
      bulkUploadTooltip: "Upload multiple photos at once",
      compositeSlot: "Composite slot",
      top_left: "Incisal Edges",
      top_center: "Facial Frontal Smile",
      top_right: "Facial Lateral Rest",
      middle_left: "Occlusal Upper",
      middle_right: "Occlusal Lower",
      bottom_left: "Buccal Left",
      bottom_center: "Buccal Center",
      bottom_right: "Buccal Right",
      fieldNotUsable: "To use this feature, please switch to a larger screen.",
      disabledReason: {
        noFiles: "Upload at least one image first.",
        filesUploading: "Wait until all images finish uploading.",
        tooManyFiles:
          "You uploaded {uploadedCount} images, but only {remainingCount} composite slots are empty. Remove {overLimitCount} image(s).",
        assignAllImages: "Assign a composite slot to all uploaded images. Missing: {count}.",
      },
    },
    dmScans: {
      title: "DM Scans",
      noFilesInDialog: "No files uploaded for now",
      position: {
        "oc-d-f": "Occlusal Down - Front",
        "oc-u-f": "Occlusal Up - Front",
        "o-c-f": "Open - Front",
        "o-c-r": "Open - Right",
        "o-c-l": "Open - Left",
        "o-c-rr": "Open - Far Right",
        "o-c-ll": "Open - Far Left",
        "c-c-f": "Closed - Front",
        "c-c-r": "Closed - Right",
        "c-c-l": "Closed - Left",
      },
      status: {
        started: "Started",
        uploaded: "Uploaded",
        published: "Published",
        rejected: "Rejected",
      },
    },
    financingPlans: {
      title: "Financing plans",
      fields: {
        financingTypes: "Financing type | Financing types",
        financingTypeOptions: {
          cash: {
            title: "Cash",
            description: "The patient will pay the full amount of the treatment upfront.",
          },
          ortho_fi: {
            title: "Orthodontist financing",
            description:
              "The patient will pay a down payment and the rest of the amount will be financed.",
          },
        },
      },
    },
    guardian: {
      sameAddress: "Guardian has the same address as patient",
      samePhone: "Guardian has the same phone as patient",
      sameEmail: "Guardian has the same email as patient",
      cantUnlinkLastManagerPayer: "Cannot unlink the last payer guardian",
      noAvailableActions: "There no available actions here.",
    },
    nextVisit: {
      subtitle: "Instructions for next visit",
      completeInstructionsFirst: "Please complete the next visit instructions first",
      instructions: {
        review_oral_health_instruction: "Review oral health",
        review_weartime_instruction: "Review weartime instructions",
        review_rubber_bands_wear: "Review rubber bands wear",
        review_dm_app: "Review DM app",
        review_dm_app_take_first_scan: "Take first scan",
        review_dm_app_review_scan_instructions: "Review scan instructions",
        i_o_scan_update: "I/O scan update",
        x_ray_update: "X-ray update",
        review_attachment_form: "Review attachments form",
        review_attachment_form_replace_attachments: "Replace attachments",
        ipr_review: "IPR review",
        manicure_teeth: "Manicure teeth",
        occlusal_adjustment: "Occlusal Adjustment",
      },
      notes: "Additional Notes",
    },
    orderAligners: {
      title: "Order Aligners",
      openLink: "Open Link",
      subtitle:
        "Start your aligner order by clicking the Link button. You’ll be redirected to the supplier portal to complete the order details. Once the aligners are ordered, click Save.",
      fields: {
        supplier: "Supplier | Suppliers",
        supplierOptions: {
          invisalign: {
            title: "Invisalign ®",
            description: "Invisalign is a company that makes aligners.",
          },
          angelalign: {
            title: "Angel Align ™",
            description: "Angel Align is a company that makes aligners.",
          },
        },
      },
      errors: {
        notOrdered: "The aligners are not ordered",
      },
      arrived: {
        title: "Date Aligners Received in Office",
      },
      applied: {
        title: "Date Aligners Delivered to Patient",
      },
    },
    orthoNeeds: {
      title: "GP Questionnaire",
      "i/oExamInformation": {
        title: "I/O exam information",
        doctorName: "Doctor name",
        dateOfExam: "Date of exam",
      },
      "lastCheckUp/hygiene": {
        title: "Last check-up / hygiene",
        dateOfCheckup: "Date of check-up",
      },
      perioClearance: {
        title: "Perio clearance",
        doctorName: "Doctor name",
      },
      fields: {
        dentitionType: {
          primary: "Primary",
          early_mixed: "Early Mixed",
          late_mixed: "Late Mixed",
          permanent: "Permanent",
        },
        archesToTreat: {
          label: "Arches to treat",
          upper: "Upper",
          lower: "Lower",
          both: "Both",
        },
        notesPlaceholder: "Write additional description",
        pendingDentalWork: {
          label: "Pending Dental Work",
        },
        orthoClearance: {
          label: "Ortho Clearance",
          cleared: "Cleared",
          not_cleared: "Not Cleared",
        },
        periodicallClearance: {
          label: "Periodontal Clearance",
          cleared: "Cleared",
          not_cleared: "Not Cleared",
        },
        bisphosphonates: {
          label: "Is the patient currently taking bisphosphonates?",
          shortLabel: "Taking Bisphosphonates",
        },
        conditions: {
          title: "Conditions",
          overbite: {
            description: "Est. Duration: 6-10 months",
          },
          growth: {
            name: "Growth / skeletal",
            description: "Est. Duration: 6-9 months",
          },
          oral_habits: {
            name: "Oral habits / thumb sucking",
            description: "Est. Duration: 6-9 months",
          },
          overjet: {
            description: "Est. Duration: 6-9 months",
          },
          space_maintenance: {
            name: "Space maintenance",
            description: "Est. Duration: 6-9 months",
          },
          crowding: {
            name: "Crowding",
            description: "Est. Duration: 6-9 months",
          },
          minor_tooth_movement: {
            name: "Minor tooth movement",
            description: "Est. Duration: 6-9 months",
          },
          missing_teeth: {
            name: "Missing teeth",
            description: "Est. Duration: 6-9 months",
          },
          open_bite: {
            name: "Open bite",
            description: "Est. Duration: 6-9 months",
          },
          underbite: {
            name: "Underbite",
            description: "Est. Duration: 6-9 months",
          },
          pre_prosthetic_alignment: {
            name: "Pre-prosthetic alignment",
            description: "Est. Duration: 6-9 months",
          },
          spacing: {
            name: "Spacing",
            description: "Est. Duration: 6-9 months",
          },
        },
      },
      teethChart: {
        reviewConfirm: "Review confirm",
        noMovement: "Teeth Not to be Moved",
        noAttachment: "Do not place attachments on these teeth",
        teethToBeExtracted: "Teeth to be Extracted",
        upperRight: "Upper Right",
        upperLeft: "Upper Left",
        lowerRight: "Lower Right",
        lowerLeft: "Lower Left",
        additionalDescription: "Write additional description if needed",
      },
      readinessLevel: {
        title: "Patient Readiness Level",
      },
    },
    orthoProposedPlan: {
      title: "Diagnostic Questionnaire",
      fields: {
        skeletalClass: {
          class_i: "I",
          class_ii: "II",
          class_iii: "III",
          no_xray: "No x-ray",
        },
        dentitionType: {
          primary: "Primary",
          early_mixed: "Early Mixed",
          late_mixed: "Late Mixed",
          permanent: "Permanent",
        },
        radiographicFindings: {
          normal: "Within normal limits",
          missing_teeth: "Missing teeth including third molars",
          caries_suspected: "Caries suspected",
          unusual: "Unusual radiographic findings",
          tapered_root_shape: "Tapered root shape (root resorption risk)",
          impacted: "Impacted",
          ectopic_eruption: "Ectopic eruption",
          impacted_third_molars: "Impacted third molars",
          other: "Other",
          no_xray: "No x-ray",
        },
        tmj: {
          asymptomatic: "Asymptomatic",
          history_of_trauma: "History of Trauma",
          clicking_right: "Clicking Right",
          clicking_left: "Clicking Left",
          pain_right: "Pain Right",
          pain_left: "Pain Left",
          limited_opening: "Limited Opening",
        },
        molarClassification: {
          class_i: "I",
          class_ii: "II",
          class_iii: "III",
          unerupted: "Unerupted",
          missing: "Missing",
        },
        midline: {
          coincident_with_face: "Coincident with face",
          u_to_r: "U to R",
          u_to_l: "U to L",
          l_to_r: "L to R",
          l_to_l: "L to L",
        },
        overbite: {
          minimal: "Minimal (0-1mm)",
          normal: "Normal (1-2mm)",
          moderate: "Moderate (3-5mm)",
          severe: "Severe (6-7mm)",
          end_to_end: "End to end (0mm)",
          openbite: "Openbite",
          openbite_tendency: "Openbite tendency",
          impinging: "Impinging",
        },
        overjet: {
          normal: "Normal (1-2mm)",
          minimal: "Minimal (<1mm)",
          moderate: "Moderate (3-6mm)",
          severe: "Severe (>6mm)",
          end_to_end: "End to end (0mm)",
          negative: "Negative",
        },
        crossbitePresent: {
          label: "Crossbite(s) Present",
          none: "None",
          posterior_right: "Posterior Right",
          posterior_left: "Posterior Left",
          posterior_bilateral: "Posterior Bilateral",
          anterior: "Anterior",
        },
        upperSpacing: {
          none: "None",
          mild: "Mild (1-3mm)",
          moderate: "Moderate (4-7mm)",
          severe: "Severe (>7mm)",
          midline_diastema: "Midline diastema",
        },
        lowerSpacing: {
          none: "None",
          mild: "Mild (1-3mm)",
          moderate: "Moderate (4-7mm)",
          severe: "Severe (>7mm)",
          midline_diastema: "Midline Diastema",
        },
        crowding: {
          none: "None",
          mild: "Mild (1-3mm)",
          moderate: "Moderate (4-7mm)",
          severe: "Severe (>7mm)",
        },
        toothSizeDiscrepancies: {
          not_apparent: "Not apparent",
          lower_than_1_5: "<1.5mm",
          higher_than_1_5: ">1.5mm",
          other: "Other",
        },
        mandibularPlaneAngle: {
          normal: "Normal (1-2mm)",
          high: "High",
          low: "Low",
          no_xray: "No x-ray",
        },
        canineClassification: {
          i_mild: "I",
          ii_full_step: "Full Step II",
          ii_mild: "Mild II",
          iii_mild: "Mild III",
          iii_full_step: "Full Step III",
          unerupted: "Unerupted",
          missing: "Missing",
        },
        upperCentralIncisorPosition: {
          upright: "Upright",
          retroclined: "Retroclined",
          proclined: "Proclined",
          no_xray: "No x-ray",
        },
        gingivalDisplayAtSmile: {
          acceptable: "Acceptable",
          excessive: "Excessive",
          limited: "Limited",
          asymmetric: "Asymmetric",
          no_record: "No record available",
        },
        gingivalContours: {
          acceptable: "Acceptable",
          hypertrophic: "Hypertrophic",
          asymmetric: "Asymmetric",
          no_record: "No record available",
        },
        smileArc: {
          acceptable: "Acceptable",
          flat: "Flat",
          reversed: "Reversed",
          asymmetric: "Asymmetric",
          no_record: "No record available",
        },
        caseType: {
          limited: "Limited",
          mild: "Mild",
          moderate: "Moderate",
          comprehensive: "Comprehensive",
        },
        treatmentTime: {
          placeholder: "Write description",
        },
        treatTheAdultPosteriorCrossbite: {
          label: "Treat The Adult Posterior Crossbite?",
          correct: "Correct",
          doNotCorrect: "Do not correct",
        },
      },
    },
    phasePlan: {
      connect: "Connect",
      scan: "Scan",
      plan: "Plan",
      monitor: "Monitor",
      refine: "Refine",
      retain: "Retain",
      initialInquiry: "Initial Inquiry",
      eligibilityCheck: "Eligibility Check",
      referralTransfer: "Referral Transfer",
      iOScan: "IO Scan",
      xRayCapture: "X-Ray Capture",
      photoRecord: "Photo Record",
      scanVerification: "Scan Verification",
      patientReview: "Patient Review",
      caseAssessment: "Case Assessment",
      treatmentBlueprint: "Treatment Blueprint",
      patientConsultation: "Patient Consultation",
      finalApprove: "Final Approve",
      appliancePlacement: "Appliance Placement",
      regularAdjustments: "Regular Adjustments",
      progressScans: "Progress Scans",
      complianceMonitoring: "Compliance Monitoring",
      patientFeedback: "Patient Feedback",
      finalAdjustments: "Final Adjustments",
      retentionPrep: "Retention Prep",
      outcomeApproval: "Outcome Prep",
      retainerDelivery: "Retainer Delivery",
      fitValidation: "Fit Validation",
      whiteningProtocol: "Whitening Protocol",
      annualMonitoring: "Annual Monitoring",
      retenrionAdjustment: "Retention Adjustments",
    },
    scheduleTCAppointment: {
      create: {
        title: "Schedule & Save",
        subtitle:
          "Please click the {externalCalendar} button below to schedule the TC consult appointment. Once you've scheduled this, please enter the consult date and time below, then select {save}.",
      },
      done: {
        title: "Confirm appointment completed",
      },
      errors: {
        notScheduled: "TC Appointment is not scheduled",
      },
    },
    visitInstructions: {
      instructionsUpdated: "Instructions updated",
      action: {
        history: "History",
      },
      title: {
        alignerDelivery: "Aligner Delivery Visit Instructions",
        finalDebond: "Final Debond Visit Instructions",
        nextVisit: "Next Visit Instructions",
        current: "Current Instructions",
        history: "Previous Instructions",
      },
      section: {
        checklist: "Checklist",
        teethList: "Teeth list",
      },
      instructionsResultState: {
        completed: "Completed",
        not_completed: "Not Completed",
        partially_fulfilled: "Partially fulfilled",
      },
      reviewOralHygiene: "Review oral hygiene",
      reviewAlignerCareInstructions: "Aligner care instructions",
      reviewDentalMonitoringAppTakeFirstScan: "Dental Monitoring: take first scan",
      reviewDentalMonitoringAppReviewScanInstructions:
        "Dental Monitoring: review scan instructions",
      reviewElasticWear: "Review elastic wear",
      interproximalReduction: "Interproximal reduction (IPR)",
      interproximalPolishing: "Interproximal polishing (IPP)",
      addAttachments: "Add attachments",
      addButtons: "Add buttons/hooks for elastics",
      reviewAlignerCompliance: "Review aligner compliance",
      reviewScansCompliance: "Review scan compliance",
      takeUpdatedIosScans: "Take updated intraoral scans (IOS)",
      takeUpdatedXRays: "Take updated X-rays",
      reviewDmAppTakeScanWithPatient: "DM app: take a scan with the patient",
      reviewDmAppReviewScanExplanation: "DM app: explain how to review scans",
      removeAttachments: "Remove attachments",
      rebondAttachments: "Rebond attachments",
    },
    treatmentType: {
      selectTreatment: "Select plan",
      referral: "Referral",
      referralFree: "Referral free",
      referralInternal: "Referral internal",
      referralPaid: "Referral paid",
      none: "No Active plan",
    },
  },
  practice: {
    website: "Website",
    mainOfficeContact: "Main Office Contact",
    gpPractice: {
      table: {
        headers: {
          address: "Office Address",
          parentGPCompany: "Parent GP Practice",
          linkedOrthoCompany: "Linked Orthodontist Practice",
        },
      },
    },
    officeWithin: "Dental office within {entity}",
    officesManagement: {
      emptyDescription: "Practices and offices you manage will show up here.",
      responsible: "Responsible",
    },
    qr: {
      generateDialog: {
        title: "Generate QR Code",
        subtitle: "Choose how patients enter your workflow",
      },
      flowType: "QR type",
      ownerStaff: "My Office Team Member",
      ownerStaffHint:
        "Select the team member who will 'own' this QR code. Otherwise, your team must assign the appropriate treatment plan.",
      addEvent: "Add Tracking Details",
      addEventDescription: "So you can share the QR code with your friends",
      event: {
        campaignSource: "Event / Location / Distributing Person",
        campaignSourcePlaceholder: "e.g., Open House, AAO, Reception Desk",
        campaignName: "Campaign / Promotion",
        campaignNamePlaceholder: "e.g., Free Consultation, Summer Sale",
      },
      cooperatingOffice: "Cooperating Office",
      cooperatingOfficePartnerHint: "The partner office involved in the referral",
      cooperatingOfficeSelectPlanHint: "The partner office involved in the treatment selection",
      cards: {
        internal: {
          title: "Internal Referrals",
          subtitle: "Internal team / event codes",
          description:
            "Create a QR code for yourself or a team member. When patients scan it and complete the questionnaire, they are added to your office’s dashboard. You can see how many patients each QR code has registered in the QR code list.",
        },
        partner: {
          title: "Partner Referrals",
          subtitle: "Referrals with a cooperating office",
          description:
            "Share this link or QR code with a cooperating office. When a patient completes the questionnaire, they are referred directly to your office and appear in Referrals In. No records are required.",
          descriptionFromMyOffice:
            "Share this link or QR code with your office. When a patient completes the questionnaire, they are referred directly to the cooperating office and appear in Referrals Out. No records are required.",
        },
        partnerSelectPlan: {
          title: "Select Plan",
          subtitle: "CoTreatment or referral with a cooperating office",
          description:
            "Share this link or QR code with a cooperating office. When a patient completes the questionnaire, they are added to that office’s dashboard. They then will select a treatment plan (refer or cotreat).",
        },
      },
      currentOffice: "My office",
      direction: {
        from: "Refer to cooperating office",
        to: "Refer to my office",
        label: "Direction",
        with: "with",
      },
      workflow: {
        label: "Workflow",
        directReferral: "Direct Referral",
        directReferralInternal: "Internal Referral",
      },
      table: {
        headers: {
          owner: "Assigned Team Member",
          registerPatientCount: "Registered Patients",
          event: "Tracking Details",
        },
      },
      detailDialog: {
        title: "QR code",
        noQrImage: "QR image is not available for this code yet.",
        redirectorUrlLabel: "Shareable NFC link",
        copyLink: "Copy link",
        shareFacebook: "Facebook",
        shareLinkedIn: "LinkedIn",
        shareOthers: "Others",
        linkCopied: "Link copied to clipboard.",
        copyFailed: "Failed to copy link to clipboard.",
        noLinkToShare: "No link is available to share for this QR code.",
        shareNotSupported:
          "Sharing is not available in this browser. Try copying the link instead.",
        downloadFailed: "Download failed. Please try again.",
      },
      usagesCountTooltip: "The number of registered patients who have used this QR code.",
      usagesDialog: {
        title: "Registered patients",
        subtitle: "QR code {code}",
      },
    },
    bannerPicture: "Banner Picture",
    contract: {
      model: {
        endDate: "End date",
        signMethodOptions: {
          manual: "Manual",
          automatic: "Automatic",
          docusign: "Docusign",
        },
      },
      form: {
        placeholder: {
          partnerCompany: "Select partner",
          initiatorCompany: "Select initiator",
        },
      },
    },
    staff: {
      table: {
        headers: {
          primaryEmail: "Primary Email",
          primaryPhone: "Primary Phone",
        },
      },
      addEditForm: {
        taxonomyCodeOptions: {
          "122300000X": "Dentist",
          "1223G0001X": "General Practice",
          "1223D0001X": "Dental Public Health",
          "1223E0200X": "Endodontics",
          "1223X0400X": "Orthodontics",
          "1223P0221X": "Pediatric Dentistry",
          "1223P0300X": "Periodontics",
          "1223P0700X": "Prosthodontics",
          "1223P0106X": "Oral & Maxillofacial Pathology",
          "1223X0008X": "Oral & Maxillofacial Radiology",
          "1223S0112X": "Oral & Maxillofacial Surgery",
        },
      },
    },
  },
  referral: {
    caseRoom: {
      pageTitle: "Case Room",
      pageSubtitle: "Manage your deals",
      summary: {
        title: "Case Summary",
      },
    },
    invite: {
      pageTitle: "Invite Colleague",
      sendInvitationTitle: "Send invitation",
      sendInvitationButton: "Send invitation",
      sendTeamInvitationButton: "Send group invitation",
      sendInvitationDescription: "Build your network - invite a provider to refer and cotreat.",
      email: "Invitee Email",
      addTooltip: "Add to your invitation list to send multiple invites together.",
      nothingHereYetDescription:
        "It looks like you're getting started - you're all set to begin! Establish partnerships and unlock collaborative care by inviting your first colleague to join CoTreatMe.",
      acceptInvitation: {
        addressForPractice: "Practice Address",
      },
      list: {
        organizationPending: "Pending setup",
        organizationConfigured: "Organization linked",
        recipientCount: "Number of invitees: {count}",
        sentBadge: "Sent",
        receivedBadge: "Received",
        searchPlaceholder: "Search by email",
        noInviteesAdded: "No invitees added",
      },
    },
    referrals: {
      incoming: {
        card: {
          payment: {
            total: "Total",
          },
        },
      },
      paidReferralFlow: {
        button: "Paid Referral",
        entryChoice: {
          title: "Choose a path",
          subtitle: "Refer the patient directly, or add records first.",
          addRecordsAndReferAction: "Add Records",
          referOnlyAction: "Refer Now",
          addRecordsAndReferDescription: "Add records first and then continue with the referral.",
          referOnlyDescription: "Send the referral without adding records first.",
        },
      },
      referPatient: {
        title: "Refer patient",
        subtitle: "Select the office you want to refer the patient to.",
        confirmButton: "Refer Patient",
      },
      referralAccepted: {
        intro:
          "Confirm that {patientName} completed their consultation. If applicable, this will follow the terms of your records agreement.",
      },
      status: {
        new: "New",
        accepted: "Accepted",
        rejected: "Rejected",
        notStarted: "Referral not started",
      },
      setRecordsPricing: {
        title: "Records Service Reimbursement Pricing",
      },
      referralRecords: {
        offer: {
          subtitle: "for receiver {companyName}",
          description:
            "Please set the pricing agreed upon for providing the service of taking the patient's records on your part.\n This price list will subsequently form an appendix to the Records agreement.",
          errors: {
            perFileMaxPricePositive:
              "For per-file pricing, the maximum price must be greater than zero.",
            perFileMaxPricePositiveTitle: "Maximum price required",
            perFileMaxPricePositiveDetail:
              "One or more rows use per-file pricing with a maximum price of zero. Enter a maximum price above zero, or switch those rows to per-pack pricing, then try again.",
          },
        },
      },
    },
  },
  report: {
    table: {
      emailCount: "No recipients | 1 recipient | {count} recipients",
      downloadTooltip: "Download this patient export (gzipped CSV)",
    },
    fields: {
      recipients: "Recipients",
      frequency: {
        title: "Frequency",
        options: {
          weekly: "Weekly",
          monthly: "Monthly",
        },
      },
    },
  },
  scheduling: {
    appointment: "Appointment | Appointments",
    minute: "1 minute | {count} minutes",
    hour: "1 hour | {count} hours",
    teamSchedule: "Team Schedule",
    teamMembers: "Team Members (All Team View)",
    all: "all",
    allTeam: "All Team",
    teamView: "Team View",
    addEditEventForm: {
      formTitle: "Schedule meeting",
      duration: "Duration",
      assignedTreatmentCoordinator: "Assigned Treatment Coordinator",
      patient: "Patient",
      videoLink: "Video Link",
      sendNotificationReminder: "Send notification reminder",
      sendNotificationReminderHint: "Send notification before appointment",
    },
    deleteForm: {
      title: "Remove scheduled meeting",
      info: "Do you really with to remove this scheduled meeting?",
    },
  },
  settings: {
    software: {
      version: "Software Version",
      viewAndManage: "View and manage current software build information.",
      currentVersion: "Current Version",
      lastUpdated: "Last Updated",
      environment: "Environment",
      changelog: "Changelog",
      changelogDescription: "Latest application updates and release notes.",
      changelogReleases: "{count} releases",
      latest: "Latest",
    },
    legal: {
      title: "Legal",
      termsAndConditionsSubtitle: "Review the terms you agreed to when creating your account.",
      viewTerms: "View Terms & Conditions",
    },
    groups: {
      color: "Role Color",
      badgeCode: "Badge Code",
      badgeCodePlaceholder: "e.g., TC, DR, ADMIN",
      badgeCodeHint: "Short code displayed as badge",
      badgePriority: "Badge Priority",
      badgePriorityPlaceholder: "0",
      badgePriorityHint: "Higher = shown first",
      protected: "Protected group",
      protectedHint:
        "Protected groups cannot be deleted and can only be assigned from the admin panel",
    },
    groupsManagement: {
      exportToClipboard: "Copy to Clipboard",
      exportToFile: "Download as File",
    },
    environment: {
      applicationEnvironment: "Application Environment",
      systemWideConfig: "Manage system-wide configurations and environment settings",
      workspaceOwner: "Workspace Owner",
      primaryOwner: "The primary owner of this workspace",
      ownerSince: "Owner since",
      transferOwnership: "Transfer ownership",
      transferOwnershipDesc: "Transfer workspace ownership to another admin",
      accountSettings: "Account Settings",
      accountConfigDesc: "General account configuration and preferences",
      workspaceUrl: "Workspace URL",
      changeUrl: "Change URL",
      workspaceName: "Workspace name",
      workspaceNameDesc: "The display name for your workspace",
      timeZoneDesc: "Default time zone for the workspace",
      selectTimezone: "Select timezone",
      defaultLanguage: "Default language",
      defaultLanguageDesc: "Default language for new members",
      selectLanguage: "Select language",
      assistantHints: "Assistant Hints",
      assistantHintsDesc: "Control when assistant hints are displayed",
      adminAssistantHints: "Administrative Assistant Hints",
      adminAssistantHintsDesc: "Show helpful hints in the administrative interface",
      chatAssistantHints: "Chat Assistant Hints",
      chatAssistantHintsDesc: "Show helpful hints in messaging and chat interfaces",
      dataCompliance: "Data & Compliance",
      dataComplianceDesc: "Manage data retention, exports, and compliance settings",
      dataResidency: "Data residency",
      changeRegion: "Change region",
      complianceExports: "Compliance exports",
      complianceExportsDesc: "Export data for legal and compliance purposes",
      requestExport: "Request export",
      legalHold: "Legal hold",
      legalHoldDesc: "Preserve data for legal proceedings",
      manageHolds: "Manage holds",
    },
    userManagement: {
      userManagement: "User Management",
      userManage: "Manage all users, their roles, and access permissions",
      systemUsers: "System Users",
      loading: "Loading users...",
      currentUserRoles: "Current user roles",
      noUser: "No users found",
      tryAdjust: "Try adjusting your filters or search criteria",
      selectGroupsForUser: "Select the roles that apply to this user",
      multiselectSearchPlaceholder: "Type to filter roles...",
      searchUsers: "Search users",
      searchByNameOrEmail: "Search by name or email...",
      allUsersLoaded: "All users have been loaded",
    },
    chatTabOptions: {
      main: "CoTreat Chat",
      patient: "Patient Chat",
    },
    enterBehaviorOptions: {
      sendMsg: "Send message",
      newLine: "New line",
    },
    messageSettings: {
      settings: "Messaging Settings",
      control: "Control how members can send messages and use messaging features",
      fileSharing: "File sharing",
      controlFile: "Control file uploads and sharing permissions",
      maxFileSize: "Maximum file size",
      setMaxSize: "Set the maximum size for uploaded files",
      checkQuota: "check available quota",
      linkPreviews: "Link previews",
      generatePreviews: "Automatically generate previews for shared links",
    },
    messagingPreferences: {
      chatPreferencesTile: "Chat Preferences",
      defaultChatTabTitle: "Default Chat Tab",
      defaultChatTabSubtitle: "Which chat opens by default",
      enterKeyBehaviorTitle: "Enter Key Behavior",
      enterKeyBehaviorSubtitle: "Always new line on mobile devices",
      showSystemMessagesTitle: "Show System Messages",
      showSystemMessagesSubtitle: "Show messages from the system",
    },
    formatControl: {
      dateInput: "Date Input Format",
      dateDisplay: "Date Display Format",
      hourDisplay: "Hour Display Format",
    },
    permissions: {
      loading: "Loading permissions...",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      myAccess: {
        permissionsTitle: "Granted Permissions",
        permissionsSubtitle: "Individual actions you're allowed to perform, grouped by area",
        noPermissions: "No permissions found",
        searchPlaceholder: "Search permissions...",
        noSearchResults: "No permissions match your search",
        badgesTitle: "Badges",
        badgesSubtitle: "Badges assigned to you through your roles, highest priority first",
        noBadges: "No badges assigned",
        developersOnlyNotice:
          "This page is for developers only. It is enabled on QA to speed up permission checks during testing.",
      },
      empty: {
        noPermissionsTitle: "No permissions available",
        noPermissionsSubtitle: "Permissions will appear here once loaded from the server",
      },
      export: {
        copiedToClipboard: "Roles exported to clipboard successfully",
      },
      import: {
        title: "Import Permissions",
        subtitle: "Import roles and permissions from another environment",
        steps: {
          input: "Input Data",
          mapping: "Map Roles",
          preview: "Preview Changes",
          results: "Results",
        },
        pasteFromClipboard: "Paste from Clipboard",
        uploadFile: "Upload File",
        jsonInputLabel: "JSON Data",
        jsonInputPlaceholder: "Paste exported JSON data here...",
        emptyInput: "Please enter or paste JSON data",
        parseError: "Failed to parse JSON data",
        invalidFormat: "Invalid export format: missing roles array",
        invalidRoleFormat: "Invalid role format: each role must have a name and permissions array",
        pastedFromClipboard: "Pasted from clipboard",
        mappingDescription:
          "Map each source role to a target role in this system. Roles with matching names are pre-selected.",
        sourceRole: "Source Role (from JSON)",
        targetRole: "Target Role (in this system)",
        ignoreRole: "- Ignore -",
        createRole: "＋ Create new role",
        createdBadge: "Created",
        newRolesTitle: "{count} role does not exist here yet | {count} roles do not exist here yet",
        newRolesSubtitle: "They will be created as new roles unless you exclude them.",
        edgesNotResolved: "Relations that could not be linked",
        sourceIncompleteTitle: "The exported file is incomplete",
        sourceMissingPermissions:
          "These roles were exported without their permissions, so importing them will not grant anything: {roles}",
        sourceUnresolvedEdges:
          "These relations point to roles missing from the file and cannot be linked: {edges}",
        legacyFormat:
          "This file uses an older export format: it stores relations by name only and carries no parent relations.",
        permissionsCount: "permissions",
        mappingSummary: "{count} role(s) will be imported",
        mappingSummaryBreakdown: "({created} created, {updated} updated)",
        parseButton: "Parse & Continue",
        importButton: "Import Permissions",
        targetGroupNotFound: "Target role not found",
        successMessage: "Successfully imported {count} role(s)",
        partialSuccessMessage: "Imported {success} role(s), {failed} failed",
        failedMessage: "Failed to import permissions",
        resultSuccess: "Applied {count} permissions successfully",
        permissionsNotFound: "Permissions not found in this system",
        invalidFileType: "The file must be in JSON format",
        previewDescription:
          "Review the changes that will be applied to each role before importing.",
        mergeStrategy: {
          label: "Import mode",
          replace: "Replace all",
          add_only: "Add only (keep existing)",
        },
        verify: {
          verified: "Verified",
          mismatch: "Check needed",
          tooltip:
            "Compares the role's effective permissions (including inherited ones) against what the export recorded.",
          unexplained: "Effective permissions missing for no known reason",
          unexpected: "Effective permissions this role gained but the export did not have",
        },
        links: {
          title: "Relations",
          children: "Children:",
          parents: "Parents:",
          missingHint:
            "Greyed-out relations point to roles that are not in this system and are not being created, so those links will be skipped.",
          status: {
            existing: "Links to an existing role",
            pending: "Links once this import creates the role",
            missing: "Role not found here - this link will be skipped",
          },
        },
        diff: {
          willBeAdded: "{count} permission(s) will be added",
          willBeRemoved: "{count} permission(s) will be removed",
          unchanged: "{count} permission(s) unchanged",
          notFoundInSystem: "{count} permission(s) not found in this system",
          noChanges: "No changes will be made",
        },
        continueToPreview: "Preview Changes",
      },
      categories: {
        names: {
          admin: "System Administration",
          auth: "User Authentication & Groups",
          contenttypes: "Content Types",
          sessions: "Session Management",
          clinic: "Clinic Management",
          authtoken: "Authentication Tokens",
          dental_monitoring: "Dental Monitoring",
          django_celery_results: "Background Tasks",
          file: "File Management",
          insurance_company: "Insurance Management",
          message: "Messaging System",
          patient: "Patient Records",
          person: "People Directory",
          practice: "Practice Management",
          referral: "Referrals",
          scheduling: "Appointment Scheduling",
          token_blacklist: "Security Tokens",
          treatment_plan: "Treatment Planning",
          user: "User Management",
          company: "Company Management",
          contract: "Contracts",
          notification: "Notifications",
          consent: "Consents",
          guardians: "Guardians",
          instructionfornextvisit: "Next Visit Instructions",
          orderaligners: "Aligner Orders",
          orthoneedspatient: "Orthodontic Needs",
          orthoproposedplan: "Orthodontic Proposed Plans",
          scheduletcappointment: "TC Appointment Scheduling",
          loggedperson: "Logged Persons",
          apikeystorage: "API Key Storage",
          bank: "Banks",
          doctorlicence: "Doctor Licenses",
          gpdoctor: "GP Doctors",
          gppractice: "GP Practices",
          orthodontist: "Orthodontists",
          orthopractice: "Orthodontic Practices",
          professionalcorporationcontract: "Professional Corporation Contracts",
          calendar: "Calendars",
          staffparticipant: "Staff Participants",
          blacklistedtoken: "Blacklisted Tokens",
          outstandingtoken: "Outstanding Tokens",
          historicalpatienttreatmentjob: "Historical Patient Treatment Jobs",
          historicalpatienttreatmentplan: "Historical Patient Treatment Plans",
          treatmentbasejobmixin: "Treatment Base Job Mixin",
          treatmentjob: "Treatment Jobs",
          treatmentplan: "Treatment Plans",
          treatmentplanbasemixin: "Treatment Plan Base Mixin",
          orbisuser: "Orbis Users",
          logentry: "System Logs",
          group: "User Groups",
          permission: "Permissions",
          token: "Authentication Tokens",
          tokenproxy: "Token Proxies",
          clinicaddress: "Clinic Addresses",
          cliniccontactemail: "Clinic Contact Emails",
          cliniccontactphone: "Clinic Contact Phones",
          clinicresponsibleperson: "Clinic Responsible Persons",
          clinicresponsiblepersoncontactemail: "Clinic Person Contact Emails",
          clinicresponsiblepersoncontactphone: "Clinic Person Contact Phones",
          clinicresponsiblepersonlogin: "Clinic Person Logins",
          clinicresponsiblepersonrole: "Clinic Person Roles",
          contenttype: "Content Types",
          event: "Events",
          externalsystemid: "External System IDs",
          groupresult: "Group Results",
          chordcounter: "Chord Counters",
          taskresult: "Task Results",
          companypicture: "Company Pictures",
          companyaddress: "Company Addresses",
          compositeviewfile: "Composite View Files",
          compositeviewgeneratedfile: "Generated Composite Files",
          filestore: "File Storage",
          messagefile: "Message Files",
          patientpicture: "Patient Pictures",
          patientaddress: "Patient Addresses",
          patientconsent: "Patient Consents",
          patientcontactemail: "Patient Contact Emails",
          patientcontactphone: "Patient Contact Phones",
          patientfile: "Patient Files",
          patientfinancingplan: "Patient Financing Plans",
          patientinsurance: "Patient Insurance",
          patientreport: "Patient Reports",
          patientparticipant: "Patient Participants",
          patienttreatmentjob: "Patient Treatment Jobs",
          patienttreatmentplan: "Patient Treatment Plans",
          photopatientfile: "Patient Photo Files",
          scanpatientfile: "Patient Scan Files",
          xraypatientfile: "Patient X-Ray Files",
          practicestaffpicture: "Practice Staff Pictures",
          practiceaddress: "Practice Addresses",
          practicecontactemail: "Practice Contact Emails",
          practicecontactphone: "Practice Contact Phones",
          practicestaff: "Practice Staff",
          practicestaffdefaultpermission: "Staff Default Permissions",
          practicestaffemail: "Staff Emails",
          practicestaffphone: "Staff Phones",
          insurancecompany: "Insurance Companies",
          platform: "Integration Platforms",
          readmessage: "Read Messages",
          orthoproposedplanpricingoption: "Plan Pricing Options",
          loggedpersoncontactemail: "Logged Person Contact Emails",
          orthodontistaddress: "Orthodontist Addresses",
          professionalcorporationcontractaddress: "Professional Corporation Contract Addresses",
          session: "Sessions",
          default: "General Permissions",
        },
        descriptions: {
          admin: "System administration and logging",
          auth: "User accounts and groups management",
          contenttypes: "Content type framework",
          sessions: "User session management",
          clinic: "Clinic operations and management",
          authtoken: "Token-based authentication",
          dental_monitoring: "Dental Monitoring integration",
          django_celery_results: "Background task management",
          file: "File storage and management",
          insurance_company: "Insurance company operations",
          message: "Internal messaging system",
          patient: "Patient record management",
          person: "People and contact management",
          practice: "Practice operations",
          referral: "Referral management",
          scheduling: "Appointment and scheduling",
          token_blacklist: "Security token management",
          treatment_plan: "Treatment planning and management",
          user: "User account management",
          company: "Company and organization management",
          contract: "Contract management",
          notification: "System notifications",
          consent: "Consent management",
          guardians: "Guardian management",
          instructionfornextvisit: "Next visit instruction management",
          orderaligners: "Aligner order management",
          orthoneedspatient: "Orthodontic needs management",
          orthoproposedplan: "Orthodontic proposed plan management",
          scheduletcappointment: "TC appointment scheduling management",
          loggedperson: "Logged person management",
          apikeystorage: "API key storage management",
          bank: "Bank management",
          doctorlicence: "Doctor license management",
          gpdoctor: "GP doctor management",
          gppractice: "GP practice management",
          orthodontist: "Orthodontist management",
          orthopractice: "Orthodontic practice management",
          professionalcorporationcontract: "Professional corporation contract management",
          calendar: "Calendar management",
          staffparticipant: "Staff participant management",
          blacklistedtoken: "Blacklisted token management",
          outstandingtoken: "Outstanding token management",
          historicalpatienttreatmentjob: "Historical patient treatment job management",
          historicalpatienttreatmentplan: "Historical patient treatment plan management",
          treatmentbasejobmixin: "Treatment base job mixin management",
          treatmentjob: "Treatment job management",
          treatmentplan: "Treatment plan management",
          treatmentplanbasemixin: "Treatment plan base mixin management",
          orbisuser: "Orbis user management",
          logentry: "System activity logging",
          group: "User group management",
          permission: "Permission management",
          token: "Authentication token management",
          tokenproxy: "Token proxy management",
          clinicaddress: "Clinic address management",
          cliniccontactemail: "Clinic email contact management",
          cliniccontactphone: "Clinic phone contact management",
          clinicresponsibleperson: "Clinic responsible person management",
          clinicresponsiblepersoncontactemail: "Clinic person email management",
          clinicresponsiblepersoncontactphone: "Clinic person phone management",
          clinicresponsiblepersonlogin: "Clinic person login management",
          clinicresponsiblepersonrole: "Clinic person role management",
          contenttype: "Content type management",
          event: "Event management",
          externalsystemid: "External system ID management",
          groupresult: "Group result management",
          chordcounter: "Chord counter management",
          taskresult: "Task result management",
          companypicture: "Company picture management",
          companyaddress: "Company address management",
          compositeviewfile: "Composite view file management",
          compositeviewgeneratedfile: "Generated composite file management",
          filestore: "File storage management",
          messagefile: "Message file management",
          patientpicture: "Patient picture management",
          patientaddress: "Patient address management",
          patientconsent: "Patient consent management",
          patientcontactemail: "Patient email contact management",
          patientcontactphone: "Patient phone contact management",
          patientfile: "Patient file management",
          patientfinancingplan: "Patient financing plan management",
          patientinsurance: "Patient insurance management",
          patientreport: "Patient report management",
          patientparticipant: "Patient participant management",
          patienttreatmentjob: "Patient treatment job management",
          patienttreatmentplan: "Patient treatment plan management",
          photopatientfile: "Patient photo file management",
          scanpatientfile: "Patient scan file management",
          xraypatientfile: "Patient X-ray file management",
          practicestaffpicture: "Practice staff picture management",
          practiceaddress: "Practice address management",
          practicecontactemail: "Practice email contact management",
          practicecontactphone: "Practice phone contact management",
          practicestaff: "Practice staff management",
          practicestaffdefaultpermission: "Staff default permission management",
          practicestaffemail: "Staff email management",
          practicestaffphone: "Staff phone management",
          insurancecompany: "Insurance company management",
          readmessage: "Message read management",
          orthoproposedplanpricingoption: "Plan pricing option management",
          loggedpersoncontactemail: "Logged person email management",
          orthodontistaddress: "Orthodontist address management",
          professionalcorporationcontractaddress:
            "Professional corporation contract address management",
          session: "Session management",
        },
      },
    },
    jobPermissions: {
      title: "Job Permissions",
      subtitle: "Manage job roles and their permissions",
      createButton: "Create Job Permission",
      createForm: {
        title: "Create New Job Permission",
        subtitle: 'Enter the job role name (e.g., "Manager", "Assistant")',
        jobNameLabel: "Job Role Name",
        jobNamePlaceholder: "e.g., Manager, Assistant, Coordinator",
        jobCodenameLabel: "Job Role Codename",
        jobCodenamePlaceholder: "e.g., manager, assistant, coordinator",
        codenameFormatError:
          "Codename must contain only lowercase letters, numbers, underscores, and dashes",
      },
      editForm: {
        title: "Edit Job Permission",
        subtitle: "Update the job role name",
      },
      list: {
        title: "Available Job Roles",
        subtitle: "Job roles available in the system",
      },
      loading: {
        message: "Loading job permissions...",
      },
      empty: {
        title: "No job permissions available",
        subtitle: "Job permissions will appear here once loaded from the server",
      },
    },
    insuranceCompanies: {
      subtitle: "Manage insurance companies available across the platform",
      searchNoResults: "No insurance companies match your search",
      emptySubtitle: "Add an insurance company to make it available across the platform",
      emptyNoAccess: "You don't have permission to view insurance companies",
      createSubtitle: "Insurance companies are shared across all practices",
      fields: {
        namePlaceholder: "e.g. Blue Cross Blue Shield",
        shortName: "Short name",
        shortNamePlaceholder: "e.g. BCBS",
        webPlaceholder: "https://example.com",
      },
    },
    platforms: {
      // Descriptive copy specific to this section; generic entity/action/field
      // strings (title, buttons, labels, delete confirm) come from the `generic` namespace.
      subtitle:
        "External systems (Cloud9, Open Dental, DocuSign, iTero, Dental Monitoring) that practice and staff API keys connect to",
      emptySubtitle: "Add a platform before creating an API key for it",
      emptyNoAccess: "You don't have permission to view integration platforms",
      createSubtitle: "The slug used to reference this platform is derived from its name",
      editSubtitle: "Changing the system clears any previously entered metadata",
      fields: {
        namePlaceholder: "e.g. Practice X Cloud9",
        urlPlaceholder: "https://...",
        noMetadata: "This platform doesn't need any additional metadata.",
      },
    },
    inviteRoles: {
      title: "Invite Roles & Specializations",
      subtitle: "Manage roles and specializations shown when inviting team members",
      roles: {
        sectionTitle: "Invite roles",
        sectionSubtitle: "Roles available in team invitation flows",
        createButton: "Add role",
        entity: "invite role",
        createForm: {
          title: "Create invite role",
          subtitle: "The role name is stored as the slug used in invitations",
          nameLabel: "Role name",
          namePlaceholder: "e.g. Treatment coordinator",
          slugPreview: "Saved as: {slug}",
          slugFormatError: "Enter a name with at least one letter or number",
          descriptionPlaceholder: "Optional short description",
          iconLabel: "Icon",
          iconPicker: {
            searchLabel: "Search icon",
            searchPlaceholder: "e.g. account, doctor, briefcase",
            loading: "Loading icon library…",
            noResults: "No icons match your search",
            showingCount: "Showing {shown} of {total} icons",
            suggestedLabel: "Suggested",
            selected: "Selected",
            customFormatError: "Use a valid Material Design Icons name (e.g. mdi-account-outline)",
          },
          colorLabel: "Text color",
          backgroundColorLabel: "Background color",
          orderLabel: "Display order",
          orderPlaceholder: "e.g. 1",
        },
        editForm: {
          title: "Edit invite role",
          subtitle: "Update how this role appears in team invitations",
          slugLocked: "Slug cannot be changed: {slug}",
          saveButton: "Save changes",
        },
        deleteConfirm: {
          title: "Delete invite role?",
          subtitle: 'This will permanently remove "{name}" and its linked data.',
        },
        list: {
          title: "Existing roles",
          subtitle: "Roles returned by the public invite API",
          slugColumn: "Slug",
          orderColumn: "Order",
          specialtiesCount: "{count} specializations",
        },
        loading: "Loading invite roles...",
        empty: {
          title: "No invite roles yet",
          subtitle: "Create a role to use it in team invitations",
        },
      },
      specialties: {
        sectionTitle: "Role specializations",
        sectionSubtitle: "Specializations linked to an invite role",
        createButton: "Add specialization",
        entity: "role specialization",
        roleFilterLabel: "Filter by role",
        roleFilterAll: "All roles",
        createForm: {
          title: "Create role specialization",
          subtitle: "Link a specialization to an invite role",
          nameLabel: "Specialization name",
          namePlaceholder: "e.g. Invisalign",
          nameFormatError: "Enter a name with at least one letter or number",
          roleLabel: "Parent role",
          rolePlaceholder: "Select a role",
          orderLabel: "Display order",
          orderPlaceholder: "e.g. 1",
        },
        editForm: {
          title: "Edit role specialization",
          subtitle: "Update this specialization for the selected invite role",
          saveButton: "Save changes",
        },
        deleteConfirm: {
          title: "Delete specialization?",
          subtitle: 'This will permanently remove "{name}".',
        },
        list: {
          title: "Existing specializations",
          subtitle: "Specializations returned by the public invite API",
          orderColumn: "Order",
        },
        loading: "Loading specializations...",
        empty: {
          title: "No specializations yet",
          subtitle: "Create a specialization or select another role filter",
        },
      },
      companyType: {
        orthodontist: "Orthodontist",
        gp: "General practice",
      },
      permissionGroups: {
        label: "Permission groups",
        placeholder: "Select permission groups",
        roleHint: "Permission groups granted to people who join with this role",
        specialtyHint: "Permission groups granted to people who join with this specialization",
      },
    },
    subscriptionProducts: {
      subtitle: "Create billing products that companies can subscribe to.",
      noAccess: "You don't have access to manage subscription products.",
      fields: {
        allowedContractTypes: "Allowed Contract Types",
        trialLength: "Trial Length",
        trialLengthUnit: "Trial Length Unit",
        trialLengthUnitOptions: {
          days: "Days",
          months: "Months",
        },
        trialDuration: "{length} {unit}",
        isDefault: "Default Product",
        countries: "Offered in countries",
        countriesHint: "Leave empty to offer this product in every country.",
        countriesUnrestricted: "All countries",
        changeableTo: "Can be changed to",
        changeableToHint: "Leave empty to allow switching to any product.",
      },
      errors: {
        invalidPrice: "Enter a valid price (e.g. 31.00).",
        contractTypesRequired: "Select at least one contract type.",
        trialPairRequired:
          "Trial length and trial length unit must both be set, or both left empty.",
      },
      history: {
        title: "Subscription history",
        subtitle: "Look up a practice to see its subscription and billing history.",
        selectCompanyPrompt: "Select a practice to see its subscription history.",
        noSubscription: "This practice doesn't have a subscription yet.",
        currentSubscription: "Current subscription",
        lastBilled: "Last billed",
        noHistory: "No history yet.",
        trial: "Trial",
        ongoing: "ongoing",
        dateRange: "{start} → {end}",
      },
      noListAccess:
        "You don't have access to view the product list, but you may still be able to add one.",
      changeHistory: "Change history",
      defaultScope: "Default for {countries}",
      defaultScopeUnrestricted: "Default fallback for all other countries",
      defaultCountryWarning:
        "Saving this replaces the current default product for the selected countries.",
      changeLine: "{field}: {from} → {to}",
      valueLine: "{field}: {value}",
    },
  },
  terms: {
    documents: {
      version: "Version {version}",
      notAccepted: "Not accepted",
    },
  },
  treatmentPlan: {
    diagram: {
      title: "Treatment Plan Progress",
      noData: "No treatment plan data available",
      states: {
        pending: "Pending",
        in_progress: "In Progress",
        completed: "Completed",
        failed: "Failed",
        excluded: "Excluded",
      },
    },
    fields: {
      referenceId: "Reference ID",
      phase: "Phase",
      nextInstruction: "Next Instruction",
      signalTypeCategory: {
        title: "Signal Category Type",
      },
      signalType: "Signal Type Key",
      dependsOn: "Depends On",
      dependsOnOperator: {
        title: "Depends On Operator",
        options: {
          and: "And",
          or: "Or",
        },
      },
      exclusionJobs: "Exclusion Jobs",
      exclusionJobsHint: "To select from diagram, click here",
      isTerminal: "Is Terminal",
      notificationAllowed: "Notification Allowed",
      systemMessageAllowed: "System Message Allowed",
      continuationType: {
        title: "Continuation Type",
        options: {
          one_way: "One Way",
          all_way: "All Way",
        },
      },
      buttonType: {
        title: "Button Type",
        options: {
          other_action: "Other Action",
          hidden: "Hidden",
          primary: "Primary",
        },
      },
      requiredReadPermissions: "Required Read Permissions",
      forCooperatePartiesType: {
        title: "For Cooperate Parties Type",
        options: {
          gp: "GP Office",
          ortho: "Orthodontic Office",
          owner: "Owner (Referral site)",
          referral_recivier: "Referral receiver (Referral site)",
        },
      },
      cooperatePartiesType: {
        title: "Cooperate Parties Type",
        options: {
          gp: "GP Office",
          ortho: "Orthodontic Office",
          owner: "Owner (Referral site)",
          referral_recivier: "Referral receiver (Referral site)",
        },
      },
      cooperatePartiesTypeInitial: {
        title: "Initial Cooperate Parties Type",
      },
      dependsOnHint: "To select from diagram, click here",
      jobTitle: "Job Title",
      dialogTitle: "Dialog Title",
      dialogMessage: "Dialog Message",
      approveText: "Approve Button Text",
      cancelText: "Cancel Button Text",
      errorMessage: "Error Message",
      successMessage: "Success Message",
      fromJob: "From Job",
      toJob: "To Job",
      reworkJobs: "Rework Jobs",
    },
    dialog: {
      duplicate: {
        title: "What will be the new name of the treatment plan?",
        nameLabel: "Name",
        namePlaceholder: "Enter treatment plan name",
      },
    },
    chooseTp: {
      title: "Select how you want to proceed with this patient",
      options: {
        cotreatment: {
          description: "Collaborate with another provider to cotreat this patient.",
        },
        referral: {
          description: "Refer the patient to another practice.",
        },
        referral_free: {
          title: "Referral Free",
          description:
            "Refer the patient to another practice. Create a free proposal, share records, and set pricing for the referral.",
        },
      },
    },
    job: {
      signals: {
        patient_created: {
          pending: "Create Patient",
          completed: "Patient Created",
        },
        patient_confirmed: {
          pending: "Validate Patient",
        },
        ortho_needs_created: {
          pending: "Fill GP Questionnaire",
          completed: "GP Questionnaire Filled",
        },
        ortho_needs_confirmed: {
          pending: "Confirm GP Questionnaire",
          return: "Reject GP Questionnaire",
          completed: "GP Questionnaire Confirmed",
        },
        ortho_needs_approved: {
          pending: "Approve GP Questionnaire",
          completed: "GP Questionnaire Approved",
        },
        ortho_proposed_plan_created: {
          pending: "Fill Diagnostic Questionnaire",
          completed: "Diagnostic Questionnaire Filled",
        },
        patient_linked_to_ortho: {
          pending: "Assign to Orthodontist",
          completed: "Patient Assigned to Orthodontist",
        },
        patient_linked_to_gp: {
          pending: "Assign to General Practitioner",
          completed: "Patient Assigned to General Practitioner",
        },
        ortho_proposed_plan_confirmed: {
          pending: "Confirm Diagnostic Questionnaire",
          completed: "Diagnostic Questionnaire Confirmed",
        },
        instructions_for_next_visit_created: {
          completed: "Instructions for Next Visit Filled",
        },
        instructions_for_next_visit_confirmed: {
          pending: "Confirm Next Visit Instructions",
          completed: "Instructions for Next Visit Confirmed",
        },
        instructions_for_next_visit_completed: {
          pending: "Complete Next Visit Instructions",
          completed: "Instructions for Next Visit Completed",
        },
        patient_financing_plan_created: {
          pending: "Fill Financing Plan",
          completed: "Financing Plan Filled",
        },
        contract_created: {
          pending: "Create Contract",
          completed: "Contract Created",
        },
        only_orthodontic_treatment: {
          pending: "Refer Patient to Orthodontist",
          completed: "Patient Referred to Orthodontist",
        },
        tc_appointment: {
          pending: "Present Plan",
          completed: "Plan Presented",
        },
        order_bracers: {
          pending: "Order Braces",
          completed: "Braces Ordered",
        },
        schedule_tc_appointment_created: {
          pending: "Schedule TC Consult Appointment",
          completed: "TC Appointment Scheduled",
        },
        schedule_tc_appointment_done: {
          pending: "Complete TC Consult Appointment",
          completed: "TC Appointment Confirmed",
        },
        order_aligners_created: {
          completed: "Aligners Ordered",
        },
        order_aligners_arrived: {
          pending: "Aligners Received in Office",
          completed: "Aligners Delivery Confirmed",
        },
        order_aligners_applied: {
          pending: "Aligners Delivered to Patient",
          completed: "Aligners Applied",
        },
        referral_created: {
          pending: "Create Referral",
          completed: "Referral Created",
        },
        patient_created_unverified: {
          pending: "Create Patient (Unverified)",
          completed: "Patient Created (Unverified)",
        },
        patient_records_created: {
          pending: "Create Patient Records",
          completed: "Patient Records Created",
        },
        ortho_proposed_plan_signed: {
          pending: "Sign Diagnostic Questionnaire",
          completed: "Diagnostic Questionnaire Signed",
        },
        patient_linked_to_tc: {
          pending: "Link to Treatment Coordinator",
          completed: "Patient Linked to Treatment Coordinator",
        },
        scanbox_handover: {
          pending: "Hand Over Scanbox",
          completed: "Scanbox Handed Over",
        },
        aligner_delivery_instructions_created: {
          completed: "Aligner Delivery Instructions Created",
        },
        aligner_delivery_instructions_confirmed: {
          completed: "Aligner Delivery Instructions Confirmed",
        },
        aligner_delivery_instructions_completed: {
          completed: "Aligner Delivery Instructions Completed",
        },
        aligner_delivery_instructions_sent_result: {
          completed: "Aligner Delivery Visit Result Sent",
        },
        next_visit_instructions_v2_created: {
          completed: "Next Visit Instructions Created",
        },
        next_visit_instructions_v2_confirmed: {
          completed: "Next Visit Instructions Confirmed",
        },
        next_visit_instructions_v2_completed: {
          completed: "Next Visit Instructions Completed",
        },
        next_visit_instructions_v2_sent_result: {
          completed: "Next Visit Result Sent",
        },
        final_debond_visit_instructions_created: {
          completed: "Final Debond Visit Instructions Created",
        },
        final_debond_visit_instructions_confirmed: {
          completed: "Final Debond Visit Instructions Confirmed",
        },
        final_debond_visit_instructions_completed: {
          completed: "Final Debond Visit Instructions Completed",
        },
        final_debond_visit_instructions_sent_result: {
          completed: "Final Debond Visit Result Sent",
        },
        patient_linked_to_gp_practice: {
          pending: "Link to GP Office",
          completed: "Patient Linked to GP Office",
        },
        patient_linked_to_ortho_practice: {
          pending: "Link to Orthodontic Office",
          completed: "Patient Linked to Orthodontic Office",
        },
        referral_accepted: {
          pending: "Consult Completed",
          completed: "Referral Accepted",
        },
        referral_rejected: {
          pending: "Decline Referral",
          completed: "Referral Rejected",
        },
        referral_appointment_created: {
          pending: "Create Referral Appointment",
          completed: "Referral Appointment Created",
        },
        referral_appointment_done: {
          pending: "Complete Referral Appointment",
          completed: "Referral Appointment Completed",
        },
        referral_status_update: {
          pending: "Update Referral Status",
          completed: "Referral Status Updated",
        },
        select_treatment: {
          pending: "Select Treatment",
          completed: "Treatment Started",
        },
        request_itero_scan: {
          pending: "Request iTero Scan",
          completed: "iTero Scan Requested",
        },
        referral_paid_proposal_price_created: {
          pending: "Create Referral Paid Proposal",
          completed: "Referral Paid Proposal Created",
        },
        add_cooperate_ortho: {
          pending: "Add Orthodontist Cooperator",
          completed: "Orthodontist Cooperator Added",
        },
        add_cooperate_gp: {
          pending: "Add GP Cooperator",
          completed: "GP Cooperator Added",
        },
        add_cooperate_tc: {
          pending: "Add Treatment Coordinator",
          completed: "Treatment Coordinator Added",
        },
        send_dm_login_link: {
          pending: "Send DM Login Link",
          completed: "DM Login Link Sent",
        },
        financing_plan_created: {
          pending: "Create Financing Plan",
          completed: "Financing Plan Created",
        },
        patient_monitoring_start: {
          pending: "Start Patient Monitoring",
          completed: "Patient Monitoring Started",
        },
        archive: {
          pending: "Archive Patient",
          completed: "Patient Archived",
        },
      },
    },
  },
} as const;

export type ModelsMessages = typeof models;
